/*
 * © 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/PyramidTemplate/PyramidCardAnimator',[
        'lodash',
        'pixi',
        'absolute/debug',
        'util/dictionary',
        'Arkadium/GameEngine/Core/EngineManagers',
        'Arkadium/GameEngine/Scenes/Nodes/SpriteNode',
        'Arkadium/GameEngine/Tween/Tween',
        'Arkadium/GameEngine/Maths/Vector2',
        'Arkadium/GameEngine/Maths/Bezier2D',
        'SolitaireShared/CardLogic/CardOp',
        'CardUI/PileView',
        'CardUI/CardView',
        'CardUI/SupplyView',
        'absolute/particleemitter',
        'absolute/coords',
        'absolute/stringmanager',
        'absolute'],
    function (_, PIXI, Debug, Dictionary, EngineManagers, SpriteNode, Tween, Vector2,
              Bezier2D, CardOp, PileView, CardView, SupplyView, ParticleEmitter, Coords, _s, Absolute) {
        "use strict";

        var PyramidCardAnimator = function (supplyView) {
            this.initPyramidCardAnimator(supplyView);
        };

        PyramidCardAnimator.prototype.initPyramidCardAnimator = function (supplyView) {
            this.SupplyView = supplyView;
            this.AnimationList = new Dictionary(SpriteNode, Array);
            this.TweenCache = new Dictionary(SpriteNode, Tween);

            this.IsInAnimationSet = false;
            this.DealCardNum = 0;
            this.IsDeal = false;
            this.IsUndoing = false;

            this.AnimatingAction = null;
            this.IsShuffling = false;
            this.NextAnimationDelay = 0;
            this.nextAnimationAction = null;

            this.AnimationDelayTimer = 0;

            this.tweensToFinish = 0;

            this.tweens = [];

            this.emitters = [];
            this.cleanUpTimeout = null;

            this.SupplyView.CardSupply.Authority.onBonusEffectEventHanlder.add(this.bonusEffect.bind(this));
            /* TODO
             supplyView.CardSupply.Authority.OnBonusEffect += Authority_OnBonusEffect;

             ClearRowEffect = new ParticleEffectNode("gameplay:pyramid-row-clear");
             ClearRowEffect.Layer = 5;

             // Cache particle effect.
             supplyView.AddChild(ClearRowEffect);
             ClearRowEffect.Trigger();
             */


            // TODO this.WinAnimator = new ButterflyWinAnimator(this.SupplyView);
            this.WinAnimator = null;

        };

        var ROTATION_ANGLE = Math.PI;
        var ANIMATION_LENGTH = 0.3;
        var ANIMATION_DELAY = 0.2;
        var CARD_DELAY = 0.05;

        var ANIM_LENGTH_DRAW = 0.2;
        var ANIM_LENGTH_MATCH = 0.1;
        var CARD_DELAY_DRAW = 0.1;

        var ROTATION_MATCH = 3.14 * 5;

        var Direction = {None: 0, Left: 1, Right: 2};

        // ParticleEffectNode ClearRowEffect;

        PyramidCardAnimator.AnimationEntry = function (pos, rot, scale, cardFlip, wait, speed) {
            this.initAnimationEntry(pos, rot, scale, cardFlip, wait, speed);
        };

        PyramidCardAnimator.AnimationEntry.prototype.initAnimationEntry = function (pos, rot, scale, cardFlip, wait, speed) {
            this.WorldPos = pos ? pos.clone() : new PIXI.Point(0, 0);
            this.WorldRot = rot;
            this.WorldScale = scale ? scale.clone() : new PIXI.Point(1, 1);
            this.CardFlip = cardFlip || 0;
            this.Wait = wait;
            this.Speed = speed;
            this.Bezier = null;
            this.Dir = Direction.None;
            this.Rotation = 0;
            this.WaitAfer = 0;
            this.ForceLayer = null;
            this.ForceLayer2 = null;

        };

        PyramidCardAnimator.prototype.bonusEffect = function (authority, data) {

            if (this.cleanUpTimeout !== null) {
                window.clearTimeout(this.cleanUpTimeout);
                this.cleanUpTimeout = null;
            }

            if (!this.particleLayer) {
                this.particleLayer = new PIXI.DisplayObjectContainer();
            }

            this.SupplyView.CardSupply.IncrementActiveAnimations();

            var bonusImage = PIXI.Sprite.fromFrame(data.bonus.toString() + '.png'),
                cardGlows = [],
                bonusBounce, bonusFade,
                emitterOptions = {
                    rate: {
                        numpan: {a: Math.max(.3 * data.bonus, 50), b: Math.max(.6 * data.bonus, 100), center: null},
                        timepan: {a: 0.1, b: 0.2, center: null}
                    },
                    mass: 1,
                    rotation: {a: [5, 10, 15, 20, 25, 30, 35, 40, 45], b: [0, 3], style: 'add'},
                    velocity: {rpan: {a: 0, b: 4, center: null}, thapan: {a: 0, b: 360, center: null}, type: 'polar'},
                    alpha: {a: 1, b: 0},
                    scale: {a: [0.25, 0.02], b: 0, center: null},
                    gravity: 0,
                    life: {a: 0.5, b: 1, center: null},
                    radius: 1,
                    crossZone: null,
                    randomDrift: null
                },
                textures = [PIXI.Texture.fromFrame('Star.png'), PIXI.Texture.fromFrame('Star_orng_dot.png'), PIXI.Texture.fromFrame('Star_yellow_dot.png')],
                emitter = new ParticleEmitter(EngineManagers.UI, textures, emitterOptions),
                pileView = this.SupplyView.GetPileView(data.pile),
                effectPosition = {
                    'x': pileView.worldTransform.tx,
                    'y': pileView.worldTransform.ty
                },
                soundToPlay = 'row' + data.row,
                self = this;

            this.emitters.push(emitter);

            function makeGlowEffect(tableau, index) {
                // fireworks-card-glow.png
                var glow = PIXI.Sprite.fromFrame('fireworks-card-glow.png'),
                    pile = this.SupplyView.GetPileView("Tableau" + tableau.toString()),
                    glowTween;

                cardGlows.push(glow);
                glow.anchor.x = glow.anchor.y = 0.5;
                glow.x = pile.worldTransform.tx;
                glow.y = pile.worldTransform.ty;
                glow.alpha = 0;

                this.particleLayer.addChild(glow);

                glowTween = new TWEEN.Tween({scale: 0, alpha: 0})
                    .easing(TWEEN.Easing.Linear.None)
                    .delay(50 * index)
                    .to({scale: [1.5, 0], alpha: [1, 0.2]}, 400)
                    .onUpdate(function () {
                        glow.scale.x = glow.scale.y = this.scale;
                        glow.alpha = this.alpha;
                    })
                    .interpolation(TWEEN.Interpolation.Bezier)
                    .start();

                this.tweens.push(glowTween);
            }

            _.each(data.tableausToLeft, function (tableau, index) {
                makeGlowEffect.call(this, tableau, index);
            }.bind(this));

            _.each(data.tableausToRight, function (tableau, index) {
                makeGlowEffect.call(this, tableau, index);
            }.bind(this));

            emitter.x = effectPosition.x;
            emitter.y = effectPosition.y;

            bonusImage.x = effectPosition.x;
            bonusImage.y = effectPosition.y;
            bonusImage.anchor.x = bonusImage.anchor.y = 0.5;
            bonusImage.scale.x = bonusImage.scale.y = 0;

            this.particleLayer.addChild(emitter);
            this.particleLayer.addChild(bonusImage);
            EngineManagers.UI.stage[0].addChild(this.particleLayer);
            let endX = 1;
            let endY = 1;
            const canvasContainer = EngineManagers.UI.container.children[0];
            if (!!canvasContainer) {
                const ratio = canvasContainer.offsetWidth / canvasContainer.offsetHeight;
                if (ratio > 1) {
                    endX = 1 / ratio;
                } else {
                    endY = ratio;
                }
            }
            
            bonusBounce = new TWEEN.Tween({scaleX: 0, scaleY: 0, alpha: 0})
                .easing(TWEEN.Easing.Exponential.Out)
                .delay(200)
                .onStart(function () {
                    emitter.emitOnce();
                    EngineManagers.Sounds.PlaySound(soundToPlay);
                })
                .to({scaleX: endX, scaleY: endY, alpha: 1}, 400)
                .onUpdate(function () {
                    bonusImage.scale.x = this.scaleX;
                    bonusImage.scale.y = this.scaleY;
                    
                    bonusImage.alpha = this.alpha;
                }).start();

            bonusFade = new TWEEN.Tween({alpha: 1})
                .easing(TWEEN.Easing.Cubic.Out)
                .delay(1000)
                .to({alpha: 0}, 500)
                .onUpdate(function () {
                    bonusImage.alpha = this.alpha;
                })
                .onComplete(function () {
                    if (!data.isPerfect) {
                        self.SupplyView.CardSupply.DecrementActiveAnimations();
                    }
                    self.cleanUpTimeout = window.setTimeout(function () {
                        if (!data.isPerfect) {
                            self.cleanUpParticles();
                        }
                    }.bind(this), 1000);
                });

            bonusBounce.chain(bonusFade);
            this.tweens.push(bonusFade);
            this.tweens.push(bonusBounce);

            // if the board is cleared
            if (data.isPerfect) {

                var perfectText = this.createTextureForPerfectText(),
                    perfectFadeIn, perfectFadeout;

                perfectText.anchor.x = 0.5;
                perfectText.anchor.y = 0.5;
                perfectText.alpha = 0;
                perfectText.x = EngineManagers.UI.width / 2;
                perfectText.y = EngineManagers.UI.height / 2;

                this.particleLayer.addChild(perfectText);

                perfectFadeIn = new TWEEN.Tween({scaleX: 0, scaleY: 0, alpha: 0})
                    .easing(TWEEN.Easing.Exponential.Out)
                    .delay(400)
                    .to({scaleX: endX, scaleY: endY, alpha: 1}, 400)
                    .onStart(function () {
                        EngineManagers.Sounds.PlaySound('perfect');
                    })
                    .onUpdate(function () {
                        perfectText.scale.x = this.scaleX;
                        perfectText.scale.y = this.scaleY;
                        perfectText.alpha = this.alpha;
                    }).start();

                perfectFadeout = new TWEEN.Tween({alpha: 1, y: perfectText.y})
                    .easing(TWEEN.Easing.Cubic.Out)
                    .delay(1000)
                    .to({alpha: 0, y: Coords.y(100)}, 1000)
                    .onUpdate(function () {
                        perfectText.alpha = this.alpha;
                        perfectText.y = this.y;
                    })
                    .onComplete(function () {
                        self.SupplyView.CardSupply.DecrementActiveAnimations();
                        self.cleanUpTimeout = window.setTimeout(function () {
                            self.cleanUpParticles();
                        }, 2000);
                    });

                perfectFadeIn.chain(perfectFadeout);

                this.tweens.push(perfectFadeIn);
                this.tweens.push(perfectFadeout);

            }

        };

        PyramidCardAnimator.prototype.BeginAnimationSet = function (numActionsToExpect) {
            if (!this.IsInAnimationSet) {
            }
            this.IsInAnimationSet = true;
            this.AnimationDelayTimer = 0;
            this.AnimationList.Clear();
            this.DealCardNum = 0;
            this.IsDeal = false;
        };

        PyramidCardAnimator.prototype.EndAnimationSet = function () {
            this.IsInAnimationSet = false;
        };


        PyramidCardAnimator.prototype.BeginAnimation = function (action, isUndoing) {
            if (!this.IsInAnimationSet) {
                this.AnimationDelayTimer = 0;
                this.AnimationList.Clear();
                this.DealCardNum = 0;
                this.IsDeal = false;
            }

            this.AnimatingAction = action;
            this.IsUndoing = isUndoing;
            // save the starting position for each card
            _.forEach(this.SupplyView.CardSupply.GetCardList(), function (card) {
                var cardView = this.SupplyView.GetCardView(card);
                if (!this.AnimationList.ContainsKey(cardView)) {
                    // create the animation list entry
                    var current = new PyramidCardAnimator.AnimationEntry();
                    current.Wait = this.AnimationDelayTimer;
                    current.Speed = 0;
                    //cardView.SceneTransform.Decompose(out current.WorldScale, out current.WorldRot, out current.WorldPos);
                    if (cardView.parent)
                        current.WorldPos = cardView.parent.toGlobal(cardView.position);

                    this.AnimationList.Add(cardView, [current]);
                }
            }, this);

            // Actions with 2 ops must be matches - determine here which direction (right or left) are they flying to.
            if (action.Ops.length == 2) {
                var pileA = action.Ops[0].GetPile(CardOp.eMoveParams.SourcePile);
                var pileB = action.Ops[1].GetPile(CardOp.eMoveParams.SourcePile);

                var cardA = this.SupplyView.GetCardView(isUndoing ? pileA.Supply.GetPile("Foundation").NthFromTop(2) : pileA.Top);
                var cardB = this.SupplyView.GetCardView(isUndoing ? pileA.Supply.GetPile("Foundation").NthFromTop(1) : pileB.Top);

                if (!this.AnimationList.Get(cardA) || !this.AnimationList.Get(cardB)) {
                    return;
                }

                var entryA = this.AnimationList.Get(cardA)[0];
                var entryB = this.AnimationList.Get(cardB)[0];

                if (this.SupplyView.GetPileView(pileA).X < this.SupplyView.GetPileView(pileB).X) {
                    entryA.Dir = isUndoing ? Direction.Right : Direction.Left;
                    entryB.Dir = isUndoing ? Direction.Left : Direction.Right;
                } else {
                    entryA.Dir = isUndoing ? Direction.Left : Direction.Right;
                    entryB.Dir = isUndoing ? Direction.Right : Direction.Left;
                }

                this.AnimationList.Get(cardA)[0] = entryA;
                this.AnimationList.Get(cardB)[0] = entryB;
            }
        };

        PyramidCardAnimator.prototype.ContinueAnimation = function (action, opNum) {
            this.SupplyView.UpdatePileChildren(false);

            var AnimSpeed = ANIMATION_LENGTH;
            var AnimDelay = ANIMATION_DELAY;
            var CardDelaySpeed = CARD_DELAY;

            if (!this.SupplyView.CardSupply.EnforceGameRules) {
                AnimSpeed = 0.2;
                AnimDelay = 0.1;
                CardDelaySpeed = 0;
            }
            if (action.Ops.length > 24) {
                AnimDelay *= 0.4; // deal
                CardDelaySpeed *= 0.4;
            }

            var op = action.Ops[opNum];
            if (op.Opcode == CardOp.Op.Move) {
                var fromPile = op.GetPile(CardOp.eMoveParams.SourcePile);
                var toPile = op.GetPile(CardOp.eMoveParams.DestPile);
                var numCards = op.GetNumber(CardOp.eMoveParams.NumCards);

                if (fromPile.Type == "Stock") {
                    AnimSpeed = ANIM_LENGTH_DRAW;
                    CardDelaySpeed = CARD_DELAY_DRAW;
                }
                if (toPile.Name == "Stock" && fromPile.Name == "DealStock") {
                    AnimSpeed = ANIM_LENGTH_DRAW;
                    CardDelaySpeed = 0;
                }

                if (this.IsUndoing) {
                    // if undoing, swap the piles
                    var tmp = fromPile;
                    fromPile = toPile;
                    toPile = tmp;

                    CardDelaySpeed *= 0.75;
                    AnimDelay *= 0.75;
                    AnimSpeed *= 0.75;
                }

                var fromPileView = this.SupplyView.GetPileView(fromPile);
                var toPileView = this.SupplyView.GetPileView(toPile);
                var rev = false;
                if (numCards < 0) {
                    numCards = -numCards;
                    rev = true;
                }

                if (numCards > 25) {
                    CardDelaySpeed *= 0.1;
                    this.IsDeal = true;
                } else if (numCards > 6) {
                    CardDelaySpeed *= 0.25;
                }

                if (fromPile.Type == "Root" || fromPileView.CardFacing == PileView.Facing.Hidden || toPileView.CardFacing == PileView.Facing.Hidden) {
                    AnimSpeed = 0;
                    AnimDelay = 0;
                    CardDelaySpeed = 0;
                } else {
                    if (this.NextAnimationDelay > 0) {
                        this.AnimationDelayTimer += this.NextAnimationDelay;
                        this.NextAnimationDelay = 0;
                    }
                }

                for (var cardNum = 0; cardNum < numCards; cardNum++) {
                    var cardIdx = cardNum + 1;
                    if (rev)
                        cardIdx = numCards - cardNum;

                    var card = toPile.NthFromTop(cardIdx);
                    var cardView = this.SupplyView.GetCardView(card);

                    var first = this.AnimationList.Get(cardView)[0];

                    var next = new PyramidCardAnimator.AnimationEntry();
                    next.Wait = this.AnimationDelayTimer;
                    next.Speed = AnimSpeed;
                    //cardView.SceneTransform.Decompose(out next.WorldScale, out next.WorldRot, out next.WorldPos);
                    //Vector2 cardPos = cardView.GetCardPositionInPile(null, true);
                    //next.WorldPos = cardView.Parent.ToGlobal(new Vector3(cardPos.X, cardPos.Y, cardView.Z));

                    var cardPos = cardView.GetCardPositionInPile(null, true);
                    next.WorldPos = cardView.Parent.toGlobal(cardPos); // TODO z order?

                    if (toPileView.CardFacing == PileView.Facing.FaceDown) {
                        next.CardFlip = 1;
                    } else {
                        next.CardFlip = 0;
                    }

                    if (this.IsDeal && numCards == 1) {
                        next.ForceLayer = CardView.TopLayer + 1 + card.Supply.Count - this.DealCardNum;
                        next.ForceLayer2 = CardView.TopLayer + 1 + card.Supply.Count + this.DealCardNum;

                        this.DealCardNum++;
                    }


                    // If this is a match animation..
                    if (fromPile.Type != "Root" && toPile.Type == "Foundation") {
                        var screenDimensions = new PIXI.Point(EngineManagers.Display.Width, EngineManagers.Display.Height);
                        var a = 0.3;
                        var b = 0.6;
                        var c = 1.5;

                        if (this.SupplyView.CurrentLayout == SupplyView.LayoutState.VerticalView) {
                            a *= 3;
                            b *= 3;
                        }

                        var p1 = new Vector2(0, 0);

                        var p2 = p1.clone();
                        if (first.Dir == Direction.Left)
                            p2.x -= screenDimensions.x * a;
                        else if (first.Dir == Direction.Right)
                            p2.x += screenDimensions.x * a;
                        p2.y -= screenDimensions.y * a;

                        var p3 = p1.clone();
                        if (first.Dir == Direction.Left)
                            p3.x -= screenDimensions.x * b;
                        else if (first.Dir == Direction.Right)
                            p3.x += screenDimensions.x * b;
                        p3.y += screenDimensions.y * c;

                        next.Bezier = new Bezier2D([p1, p2, p3], Bezier2D.BezierPointType.Control);
                        next.Speed = ANIM_LENGTH_MATCH * 10;
                        next.Rotation = ROTATION_MATCH;

                        if (fromPile.Name == "Tableau0")
                            next.WaitAfter = 1;
                    }

                    if (this.IsUndoing && fromPileView.CardFacing == PileView.Facing.Hidden) {
                        var screenDimensions = new PIXI.Point(EngineManagers.Display.Width, EngineManagers.Display.Height);

                        var newFirst = new PyramidCardAnimator.AnimationEntry();
                        newFirst.WorldPos = toPileView.ToGlobal(new PIXI.Point(0, 0));
                        newFirst.WorldPos.y = screenDimensions.y + 20;
                        this.AnimationList.Get(cardView)[0].WorldPos.x = newFirst.WorldPos.x;
                        this.AnimationList.Get(cardView)[0].WorldPos.y = newFirst.WorldPos.y;

                        next.WorldPos = toPileView.toGlobal(new PIXI.Point(0, 0));
                        // TODO next.WorldRot = Quaternion.Zero;

                        next.Speed = 1.0;
                        next.Rotation = 0.0;

                        cardView.Visible = true;
                    }

                    this.AnimationList.Get(cardView).push(next);

                    if (numCards > 1)
                        this.AnimationDelayTimer += CardDelaySpeed;
                }

                this.AnimationDelayTimer += AnimDelay;
            }
        }
        PyramidCardAnimator.prototype.createTextureForPerfectText = function () {
            var canvas = document.createElement('canvas');
            canvas.width = 700;
            canvas.height = 300;
            var ctx = canvas.getContext('2d');
            ctx.lineJoin = "round";

            var textPosition = 170;

            var text = _s('dialogs.perfectEarnedHeadline');

            ctx.moveTo(0, 100);

            var gradient = ctx.createLinearGradient(0, 50, 0, textPosition);
            gradient.addColorStop(0, "#fffcf3");
            gradient.addColorStop(0.33, "#ffefb0");
            gradient.addColorStop(0.66, "#ffdb4a");
            gradient.addColorStop(1, "#f3c307");

            var strokeGradient = ctx.createLinearGradient(0, 0, 0, textPosition);
            strokeGradient.addColorStop(0, "#ffeb52");
            strokeGradient.addColorStop(0.5, "#ffe478");
            strokeGradient.addColorStop(0.8, "#fea704");
            strokeGradient.addColorStop(1, "#c76c01");

            var blur = 100;

            ctx.font = 'bold ' + Absolute.ScreenMetrics.getResScale() * 65 + 'px Arial';

            ctx.shadowColor = '#ffd429';
            ctx.shadowBlur = blur;

            ctx.shadowOffsetX = 0;
            ctx.shadowOffsetY = -6;


            ctx.strokeStyle = strokeGradient;
            ctx.lineWidth = 10;
            ctx.strokeText(text, 70, textPosition);

            ctx.shadowColor = 'rgba(153,119,58, 0.8)';
            ctx.shadowBlur = 3;
            ctx.shadowOffsetX = -1;
            ctx.shadowOffsetY = -1;

            ctx.strokeStyle = strokeGradient;
            ctx.lineWidth = 10;
            ctx.strokeText(text, 70, textPosition);

            ctx.shadowColor = 'rgba(243, 68, 0 , 0.9)';
            ctx.shadowBlur = 3;
            ctx.shadowOffsetX = 1;
            ctx.shadowOffsetY = 1;

            ctx.fillStyle = gradient;
            ctx.fillText(text, 70, textPosition);
            ctx.stroke();

            return new PIXI.Sprite(PIXI.Texture.fromCanvas(this.trimCanvas(canvas, ctx)));
        };
        PyramidCardAnimator.prototype.trimCanvas = function (canvas, context) {
            var copy = document.createElement('canvas').getContext('2d'),
                pixels = context.getImageData(0, 0, canvas.width, canvas.height),
                bound = {
                    top: null,
                    left: null,
                    right: null,
                    bottom: null
                };
            this.findTransparentPixels(bound, pixels, canvas);
            return this.getTrimmedCanvas(bound, copy, context);
        };

        PyramidCardAnimator.prototype.findTransparentPixels = function (bound, pixels, canvas) {
            var x, y;
            var pixelsCount = pixels.data.length;
            for (var i = 0; i < pixelsCount; i += 4) {
                if (pixels.data[i + 3] !== 0) {
                    x = (i / 4) % canvas.width;
                    y = ~~((i / 4) / canvas.width);
                    this.checkBounds(bound, x, y);
                }
            }
        };

        PyramidCardAnimator.prototype.getTrimmedCanvas = function(bound, context, prevContext) {
            var trimHeight = bound.bottom - bound.top,
                trimWidth = bound.right - bound.left,
                trimmed = prevContext.getImageData(bound.left, bound.top, trimWidth, trimHeight);
            context.canvas.width = trimWidth;
            context.canvas.height = trimHeight;
            context.putImageData(trimmed, 0, 0);
            return context.canvas;
        };

        PyramidCardAnimator.prototype.checkBounds = function (bound, x, y) {
            if (!bound.top) bound.top = y;
            if (!bound.left) bound.left = x;
            else if (x < bound.left) bound.left = x;
            if (!bound.right) bound.right = x;
            else if (bound.right < x) bound.right = x;
            if (!bound.bottom) bound.bottom = y;
            else if (bound.bottom < y) bound.bottom = y;
        };


        PyramidCardAnimator.prototype.EndAnimation = function (action, callThisWhenFinished) {
            this.tweensToFinish = 0;
            this.TweenCache.Clear();

            // now, actually perform all the tweens that we set up earlier
            _.forEach(this.AnimationList.GetKeys(), function (node) {
                var tweenList = this.AnimationList.Get(node);
                if (tweenList.length < 2)
                    return; // no anim for this node

                if (node instanceof CardView)
                    node.Animating = true;

                this.tweensToFinish++;

                var tween;
                if (this.TweenCache.ContainsKey(node)) {
                    tween = this.TweenCache.Get(node).Then();
                } else {
                    var tweens = Tween.GetTweens(node);
                    if (tweens != null && tweens.length > 0)
                        tween = tweens[0].Then();
                    else
                        tween = Tween.Start(node);

                    // TODO tween.Completed += (t, n) => TweenCache.Remove(n.Data as SceneNode);
                    this.TweenCache.Add(node, tween);
                }

                for (var i = 0; i < tweenList.length; i++) {
                    var tweenEntry = tweenList[i];

                    // First, take all of the world transform stuff and take it back to the node's local space.
                    // Vector3 pos = Vector3.TransformCoordinate(tweenEntry.WorldPos, node.Parent.InverseSceneTransform);
                    // Vector3 scale = Vector3.TransformNormal(tweenEntry.WorldScale, node.Parent.InverseSceneTransform);
                    var pos = node.parent.toLocal(tweenEntry.WorldPos);
                    var scale = node.scale.clone();

                    // Set the forced card layer before we start tweening.

                    if (i == 0) {
                        node.SetPosition(pos);
                        node.SetScale(scale);

                        if (tweenEntry.ForceLayer != null && node instanceof CardView) {
                            node.LayerWhileAnimating = tweenEntry.ForceLayer.Value;
                        }
                    } else {
                        if (tweenEntry.Wait > 0) {
                            Debug.log("x");
                        }

                        tween = tween.Wait(tweenEntry.Wait).Then();
                        if (tweenEntry.Wait > 0 && this.nextAnimationAction != null) {
                            var callAnimation = this.nextAnimationAction;
                            tween = tween.Call(callAnimation).And();
                            this.nextAnimationAction = null;
                        }
                        if (tweenEntry.ForceLayer2 != null && node instanceof CardView) {
                            tween = tween.Call(function () {
                                node.LayerWhileAnimating = tweenEntry.ForceLayer2.Value;
                            }).And();
                        }

                        if (tweenEntry.Bezier == null) {
                            if (this.IsUndoing) {
                                tween = tween.MoveTo(pos, tweenEntry.Speed, TWEEN.Easing.Quintic.Out)
                                    .And()
                                    .RotateTo(0, 0.0);
                            } else {
                                tween = tween.MoveTo(pos, tweenEntry.Speed, TWEEN.Easing.Quintic.Out)
                                    .And()
                                    .RotateTo(0, 0.5);
                            }
                        } else {
                            tween = tween.MoveByBezier(tweenEntry.Bezier, tweenEntry.Speed)
                                .And()
                                //.RotateTo(tweenEntry.Rotation, tweenEntry.Speed);
                                .RotateBy(tweenEntry.Rotation, tweenEntry.Speed);
                        }

                        tween = tween.And()
                            .ScaleTo(scale, tweenEntry.Speed, TWEEN.Easing.Quintic.Out);

                        if (node instanceof CardView)
                            tween = tween.And().CustomTo(
                                node.SetCardFlipAngle.bind(node),
                                node.GetCardFlipAngle.bind(node),
                                tweenEntry.CardFlip,
                                tweenEntry.Speed,
                                TWEEN.Easing.Cubic.Out);
                    }

                    if ((tweenEntry.ForceLayer != null || tweenEntry.ForceLayer2 != null) && node instanceof CardView) {
                        tween = tween.Call(function (n) {
                            if (n instanceof CardView)
                                n.LayerWhileAnimating = null;
                        }.bind(this));
                    }
                }
                tween = tween.Call(this.StopAnimating.bind(this));
                tween = tween.Call(function () {
                    this.EndAnimTrigger(callThisWhenFinished);
                }.bind(this));
            }, this);
            this.AnimationList.Clear();
            this.TweenCache.Clear();

            //lock (AnimationLock)
            //{
            if (this.tweensToFinish == 0) {
                callThisWhenFinished(action);
            }
            //}
        };
        PyramidCardAnimator.prototype.GetTweenedTimeScale = function (node, prop, timeScale) {
            timeScale = EngineManagers.TimeScale;
            return timeScale; // TODO where called?
        };

        PyramidCardAnimator.prototype.SetTweenedTimeScale = function (node, prop, timeScale) {
            EngineManagers.TimeScale = timeScale;
        };

        PyramidCardAnimator.prototype.StopAnimating = function (node) {
            if (node instanceof CardView)
                node.Animating = false;
        };

// TODO     public event ShuffleFinishedDelegate OnShuffleFinished;

        PyramidCardAnimator.prototype.EndAnimTrigger = function (onComplete) {
            //lock (AnimationLock)
            //{
            this.tweensToFinish--;
            if (this.tweensToFinish == 0) {
                if (this.IsShuffling) {
                    this.IsShuffling = false;
                    if (this.OnShuffleFinished != null)
                        this.OnShuffleFinished();
                }
            }

            if (onComplete != null && !onComplete.called) {
                onComplete(this.AnimatingAction);
                onComplete.called = true;
            }
            //}
        };


        PyramidCardAnimator.prototype.BeginShuffleAnimation = function () {
            if (this.WinAnimator != null)
                this.WinAnimator.EndAnimation();
            this.IsShuffling = true;
        };

        PyramidCardAnimator.prototype.IsShuffleAnimationRunning = function () {
            return this.IsShuffling;
        };

        /// <summary>
        /// Don't do anything - this game type has no win animation.
        /// </summary>
        PyramidCardAnimator.prototype.TriggerWinAnimation = function (endAnimationCallback) {
            this.WinAnimator = null; // Make sure we have no win animation, since this game doesn't have one.
            if (endAnimationCallback != null)
                endAnimationCallback();
        };

        PyramidCardAnimator.prototype.ShouldShowEndingPopup = function () {
            if (this.WinAnimator == null)
                return true;
            else
                return this.WinAnimator.ShouldShowEndingPopup();
        };

        PyramidCardAnimator.prototype.DoesAnimationBlockInput = function (action) {
            return false; // nothing especially blocks input in this game
        };


        PyramidCardAnimator.prototype.DelayNextAnimation = function (delaySeconds) {
            // this.NextAnimationDelay = delaySeconds;
        };


        PyramidCardAnimator.prototype.OnNextAnimationStart = function (action) {
            this.nextAnimationAction = action;
        };

        PyramidCardAnimator.prototype.onHide = function () {
            this.cleanUpParticles();
        };

        PyramidCardAnimator.prototype.cleanUpParticles = function () {

            _.each(this.emitters, function (emitter) {
                emitter.destroy();
            });

            this.emitters.length = 0;

            if (this.particleLayer) {
                EngineManagers.UI.stage[0].removeChild(this.particleLayer);
                this.particleLayer = null;
            }

            // cleaning up tweens causes a mess with animation tracking. decrementing doesn't occur properly
            /*_.each(this.tweens, function(tween) {
                tween.stop();
                TWEEN.remove(tween);
            });

            this.tweens.length = 0;*/

            if (this.cleanUpTimeout !== null) {
                window.clearTimeout(this.cleanUpTimeout);
                this.cleanUpTimeout = null;
            }

        };

        return PyramidCardAnimator;

    });

